import React, { useContext } from "react";
import { Button, Container } from "react-bootstrap";
import { useNavigate } from "react-router";
import { Context } from "../../Shared/Context/GlobalContext";
import { Link } from "react-router-dom";
import routes from "../../Helpers/Routes.json";
import { useTranslation } from "react-i18next";

export default function AccountPage() {
  const { user, logout, domain } = useContext(Context);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const accountUrl = domain?.shop?.account_url || "#";

  return (
    <Container className="py-4" style={{ maxWidth: "500px" }}>
      <div className="text-center mb-4">
        <img
          src={user.avatar_url}
          alt="profile"
          width={80}
          height={80}
          className="rounded-circle shadow-sm"
        />
        <h3 className="h5 mt-2 mb-1 fw-bold">{user.username}</h3>
        <small className="text-muted">{user.email}</small>
      </div>

      <div className="card p-3">
        <a
          href={accountUrl}
          target="_blank"
          rel="noreferrer"
          className="btn btn-outline-secondary w-100 mb-2 rounded-pill"
        >
          {t("Editar mi cuenta")}
        </a>

        <Link
          to={routes.OrdersPage.index}
          className="btn btn-outline-secondary w-100 mb-2 rounded-pill"
        >
          {t("Mis pedidos")}
        </Link>

        <Button
          variant="outline-secondary"
          className="w-100 mb-2 rounded-pill"
          onClick={() => navigate(-1)}
        >
          {t("Volver")}
        </Button>

        <Button
          variant="outline-danger"
          size="sm"
          className="w-100 rounded-pill"
          onClick={() => {
            if (window.confirm(t("¿Seguro que quieres cerrar sesión?"))) {
              logout();
              navigate(routes.Homepage.index);
            }
          }}
        >
          {t("Cerrar sesión")}
        </Button>
      </div>
    </Container>
  );
}
